import { z } from "zod";
import { ScheduleLifecycleErrorCode } from "@common/types/domains/accounting/schedule";

export const scheduleApplicationBulkFailureSchema = z.object({
    applicationId: z.string().uuid(),
    message: z.string(),
    errorCode: z.literal(ScheduleLifecycleErrorCode.periodLocked).optional(),
    lockDate: z.string().optional(),
    lockedMonths: z.array(z.string()).optional(),
});

export type ScheduleApplicationBulkFailure = z.infer<
    typeof scheduleApplicationBulkFailureSchema
>;
